import { isNil } from 'lodash';
import { isValid } from 'kennitala-utility';
import { isEmail } from 'helpers';

type FormValue = boolean | number | string;

export type FormValues = {
	[key: string]: FormValue | FormValue[];
};

export function isValidKennitala(value = '') {
	return typeof value === 'string' && 10 === value.length && isValid(value);
}

export function isInputHasKennitala({ value }: HTMLInputElement) {
	return isValidKennitala(value);
}

export function isInputHasEmail({ value }: HTMLInputElement) {
	return isEmail(value);
}

export function isDefined(value: unknown) {
	if (typeof value === 'string' && value.trim() === '') {
		return false;
	}
	return !isNil(value);
}

export function getFormValues(formElement: HTMLFormElement) {
	return Array.from(formElement).reduce((acc: FormValues, input: any) => {
		if (input.name) {
			switch (input.type) {
				case 'checkbox':
				case 'radio':
					acc[input.name] = input.checked;
					break;
				case 'number':
					acc[input.name] = +input.value;
					break;
				case 'select-one':
					acc[input.name] = input.value;
					break;
				default:
					acc[input.name] = input.value;
			}
		}
		return acc;
	}, {});
}

export type FormErrors = {
	[name: string]: string[];
};

export const validateForm = (formValues: FormValues) => {
	return Object.keys(formValues).reduce((errors: FormErrors, name: string) => {
		const value = formValues[name];

		if ('boolean' === typeof value || 'number' === typeof value) {
			return errors;
		}

		if (isNil(value)) {
			const msg = `Invalid value: ${name}`;
			return addErrorMessage(errors, name, msg);
		}

		if ('string' === typeof value) {
			if (!value.trim()) {
				const msg = `Invalid value: ${name}`;
				addErrorMessage(errors, name, msg);
			}
			return errors;
		}

		return errors;
	}, {});
};

export function addErrorMessage(errors: FormErrors, name = '', message = '') {
	if (errors[name]) {
		errors[name].push(message);
	} else {
		errors[name] = [message];
	}
	return errors;
}

export function formatErrors(errors: FormErrors, translate: Function) {
	return Object.keys(errors).reduce((err: any, key) => {
		err[key] = errors[key].map(i => translate(i)).join('. ');
		return err;
	}, {});
}
